const ZXing = {};
export default ZXing;
